import { levelsStickyCss } from 'components/Tree/Tree.styles';

// the height of the root tree items
const rootTreeItemHeight = 34;

export default theme => ({
  root: {
    '& .MuiTreeView-root': {
      '&> .MuiTreeItem-root > .MuiTreeItem-content': {
        height: rootTreeItemHeight,
        '& .MuiTreeItem-label': {
          '& .MuiTypography-body2': {
            fontSize: 14,
            marginLeft: 8
          },
          '& .MuiSvgIcon-root, svg': {
            padding: 0
          }
        }
      },
      // override CSS to account for adapted root tree item height (computes correct 'top' property for sticky tree items)
      ...levelsStickyCss([rootTreeItemHeight])
    }
  }
});
